import { computed, toValue } from 'vue'
import type { ComputedRef, MaybeRefOrGetter } from 'vue'

import type { UiKitMessages, UiKitMessageSection } from '@ui/utils/defaultMessages'
import { DEFAULT_MESSAGES } from '@ui/utils/defaultMessages'

import { useUiKitConfig } from './useUiKitConfig'

export function useUiKitMessages<S extends UiKitMessageSection>(
  section: S,
  override?: MaybeRefOrGetter<Partial<UiKitMessages[S]> | null | undefined>,
): ComputedRef<UiKitMessages[S]> {
  const config = useUiKitConfig()

  return computed(() => ({
    ...DEFAULT_MESSAGES[section],
    ...toValue(config.messages)?.[section],
    ...toValue(override),
  }))
}
